import { render, staticRenderFns } from "./ShowDataControl.vue?vue&type=template&id=a5a31ee4&"
import script from "./ShowDataControl.vue?vue&type=script&lang=js&"
export * from "./ShowDataControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports